import { render, staticRenderFns } from "./OrgSettingsConfig.vue?vue&type=template&id=c5c370d4&scoped=true&"
import script from "./OrgSettingsConfig.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsConfig.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsConfig.vue?vue&type=style&index=0&id=c5c370d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c370d4",
  null
  
)

export default component.exports